export const parseIpAddressesList = (value: string): string[] =>
  value
    .split(/[\s,]+/)
    .map((ip) => ip.trim())
    .filter(Boolean);

export const formatIpAddressesList = (value: string): string => parseIpAddressesList(value).join(', ');
